import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'napa-clock-icon',
  standalone: true,
  imports: [],
  templateUrl: './clock-icon.component.html',
  styleUrl: './clock-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClockIconComponent {}
